import { createFileRoute } from "@tanstack/react-router";

import { Results } from "~/components/feature/results/Results";

export const Route = createFileRoute("/_app/dashboard/results")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Results />;
}
